import { ReactComponent as TelegramColorSvg } from '../../assets/images/telegram.svg';

export const TelegramColorIcon: SvgIcon = (props) => {
    return <TelegramColorSvg {...props} />;
};
